import { render, staticRenderFns } from "./Geolocalizacion.vue?vue&type=template&id=ffaf1002&"
import script from "./Geolocalizacion.vue?vue&type=script&lang=js&"
export * from "./Geolocalizacion.vue?vue&type=script&lang=js&"
import style0 from "./Geolocalizacion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports